import { render, staticRenderFns } from "./renderer.vue?vue&type=template&id=16fd6153&scoped=true&"
import script from "./renderer.vue?vue&type=script&lang=ts&"
export * from "./renderer.vue?vue&type=script&lang=ts&"
import style0 from "./renderer.vue?vue&type=style&index=0&id=16fd6153&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16fd6153",
  null
  
)

export default component.exports